import React, { Component } from 'react';
import { ValidationError } from 'pages/upload.page/publish-video/fragments';
import { wrapURLs } from 'utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';

export class TextBox extends Component {
  state = {
    checked: false,
  };

  toggleChecked = () => {
    const isChecked = !this.state.checked;
    this.setState({
      checked: isChecked,
    });
  };

  render() {
    const {
      input,
      required,
      placeholder,
      text,
      meta: { error },
    } = this.props;
    const id = `text-box-checkbox-${input.name}`;

    return (
      <div className="text-box" data-e2e="ct-text-box">
        <div className={`d-flex m-0${error ? ' validation-error-border p-2' : ''}`}>
          {required && (
            <div className="d-flex justify-content-center align-content-center text-box__checkbox-wrapper">
              <input {...input} id={id} type="checkbox" className="form-control d-none" />
              <label htmlFor={id} className="text-box__label" onClick={this.toggleChecked}>
                <div
                  className={`d-flex justify-content-center align-content-center text-box__checkbox${
                    this.state.checked ? ' text-box__checkbox--checked' : ''
                  }`}
                  data-e2e="textBoxCheckbox"
                >
                  <FontAwesomeIcon icon={faCheck} className={`${this.state.checked ? ' d-block' : ' d-none'}`} />
                </div>
              </label>
            </div>
          )}
          <div className="d-flex align-content-end align-items-center text-box__text p-2">
            <p
              dangerouslySetInnerHTML={{
                __html: text.length === 0 && !required ? placeholder : `${wrapURLs(text)}${required ? ' *' : ''}`,
              }}
            ></p>
          </div>
        </div>
        <ValidationError error={error} />
      </div>
    );
  }
}
